<div class="background"></div>
<div id="spinner-wrapper">
  <div class="progress-spinner progress-spinner-active" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>ner>
